import { Component, inject } from '@angular/core';
import { PushPipe } from '@ngrx/component';
import { Store } from '@ngrx/store';

import { TerraIconModule } from '@ninety/terra';

import { MazActions } from '../../_state/maz.actions';
import { MazSelectors } from '../../_state/maz.selectors';

@Component({
  selector: 'ninety-maz-common-questions',
  templateUrl: './maz-common-questions.component.html',
  styleUrls: ['./maz-common-questions.component.scss'],
  standalone: true,
  imports: [TerraIconModule, PushPipe],
})
export class MazCommonQuestionsComponent {
  private store = inject(Store);

  protected readonly commonQuestions$ = this.store.select(MazSelectors.selectCommonQuestions);

  questionClicked(question: string): void {
    this.store.dispatch(MazActions.sendMessageToMaz({ userInput: question }));
  }
}
